// global.$ = global.jQuery = require('jquery');
import { createApp } from 'vue'
import mitt from 'mitt'
// import naive from "naive-ui";
import ViewWrapperView from '@vueapp/views/ViewWrapperView.vue'

// import VueTippy from 'vue-tippy'

export class ViewWrapper {

	constructor( elements ) {
        let _this = this
        if ( elements.length ) {
            elements.forEach(function (item, key) {
            	const emitter = mitt()
				const app = createApp(ViewWrapperView, {
					postId: item.getAttribute('data-post-id'),
					postSlug: item.getAttribute('data-post-slug')
				})
				app.config.globalProperties.emitter = emitter
				// app.use(naive)
				app.mount('#' + item.getAttribute('id') )    

            })
        }
	}
}